import React from "react";
import { Link } from "react-router-dom";
import { HelpIcon, ProfileIcon } from "@gataca/design-system/web";
import styles from "./Badges.module.scss";
import {
  gaImages,
  helpMenu,
  gaColors,
  profileMenuOptions,
} from "../../assets/globalConstants";
import GaImage from "../../components/atoms/Image/Image";
import DropdownMenu from "../../components/DropdownMenu/DropdownMenu";
import BadgesList from "./badgesList/BadgesList";

type IBadgesProps = {};

const Badges: React.FC<IBadgesProps> = () => {
  return (
    <>
      <div className={styles.badgesMainContainer}>
        <header>
          <Link to={"/badges"} onClick={() => "/badges"}>
            <GaImage image={gaImages?.gatacaLogo} />
          </Link>
          <div className={styles.options}>
            <DropdownMenu
              menuOptions={helpMenu}
              iconComponent={() => (
                <HelpIcon size={"24"} style={"outline"} />
              )}></DropdownMenu>
            <DropdownMenu
              menuOptions={profileMenuOptions}
              iconComponent={() => (
                <ProfileIcon
                  size={"32"}
                  color={gaColors?.primaryColor}
                  style={"filled"}
                />
              )}></DropdownMenu>
          </div>
        </header>
        <main>
          <BadgesList />
        </main>
      </div>
    </>
  );
};

Badges.defaultProps = {};

export default Badges;
